import React from "react";

import { PictureAsPdf as PdfIcon } from "@mui/icons-material";
import { Typography, Box, List, ListItem, ListItemIcon, ListItemText, Link } from "@mui/material";

import { MainLayout } from "../components/layout/MainLayout";
import { CACard } from "../components/ui";
import type { RootState } from "../store";
import { useAppSelector } from "../store/hooks";

export const DocumentsPage: React.FC = () => {
  const selectedService = useAppSelector((state: RootState) => state.service.selectedService);

  const serviceState = selectedService?.state ?? "NSW";

  // Check if public liability is state-based
  const isPublicLiabilityStateBased = ["WA", "NSW", "ACT"].includes(serviceState.toUpperCase());

  // Document sections configuration
  const documentSections = [
    {
      title: "Public Liability",
      documents: [
        {
          name: isPublicLiabilityStateBased
            ? `Public Liability - Certificate of Currency (${serviceState.toUpperCase()})`
            : "Public Liability - Certificate of Currency",
          url: isPublicLiabilityStateBased
            ? `https://link.campaustralia.com.au/MailContent/Partners/PublicLiability/PublicLiabilityCOC-${serviceState.toUpperCase()}.pdf`
            : "https://link.campaustralia.com.au/MailContent/Partners/PublicLiability/PublicLiabilityCOC.pdf",
        },
      ],
    },
    {
      title: "Workcover",
      documents: [
        {
          name: `Workcover - Certificate of Currency (${serviceState})`,
          url: `https://link.campaustralia.com.au/MailContent/Partners/Workcover/${serviceState}.PDF`,
        },
      ],
    },
    {
      title: "COVIDSAFE Plan",
      documents: [
        {
          name: "Camp Australia COVID Safe Plan",
          url: "https://link.campaustralia.com.au/MailContent/Partners/COVIDSAFE-Plan/CA COVID Safe Plan.pdf",
        },
      ],
    },
  ];

  const handleDocumentClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <MainLayout>
      <Box sx={{ p: 3 }}>
        {documentSections.map((section) => (
          <CACard key={section.title} sx={{ mb: 3 }}>
            <Box sx={{ padding: 2 }}>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                {section.title}
              </Typography>
              <List disablePadding>
                {section.documents.map((document, index) => (
                  <ListItem
                    key={index}
                    disablePadding
                    sx={{
                      "& .MuiListItemText-root": {
                        margin: 0,
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <PdfIcon color="secondary" />
                    </ListItemIcon>
                    <ListItemText>
                      <Link
                        component="button"
                        variant="body1"
                        onClick={() => handleDocumentClick(document.url)}
                        sx={{
                          textAlign: "left",
                          textDecoration: "none",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {document.name}
                      </Link>
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Box>
          </CACard>
        ))}

        {!selectedService && (
          <CACard>
            <Box sx={{ padding: 2 }}>
              <Typography variant="body1" color="text.secondary" align="center">
                Please select a service to view available documents.
              </Typography>
            </Box>
          </CACard>
        )}
      </Box>
    </MainLayout>
  );
};
